export default "__VITE_ASSET__zpkAXFGP__"